import { Component, EventEmitter, Input, Output } from '@angular/core';

export class PageEvent {
  pageIndex!: number;
}

export interface PaginatorDefaultOptions {
  pageSize: number;
  pageSizeOptions: number[];
}

const PAGINATOR_DEFAULT_OPTIONS: PaginatorDefaultOptions = {
  pageSize: 5,
  pageSizeOptions: [20, 50, 100]
};

@Component({
  standalone: false,
  selector: 'app-sd-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {

  @Input()
  get length(): number {
    return this.lengthValue;
  }
  set length(value: number) {
    this.lengthValue = value;
  }
  private lengthValue: number = 0;

  @Input()
  pageIndex = 0;

  @Input()
  get pageSize(): number {
    return this.pageSizeValue;
  }
  set pageSize(value: number) {
    this.pageSizeValue = value;
  }
  private pageSizeValue: number = PAGINATOR_DEFAULT_OPTIONS.pageSize;

  @Output()
  page = new EventEmitter<PageEvent>();

  get from(): number {
    return Math.min(this.pageIndex * this.pageSize + 1, this.length);
  }

  get to(): number {
    return Math.min(Number(this.pageSize) + this.pageIndex * this.pageSize, this.length);
  }

  get isFirstPage(): boolean {
    return this.pageIndex !== 0;
  }

  get isLastPage(): boolean {
    return this.pageIndex !== this.lastPageIndex;
  }

  get lastPageIndex() {
    return Math.max(this.getNumberOfPages() - 1, 0);
  }

  onPreviousPage() {
    this.page.emit({
      pageIndex: this.pageIndex - 1
    });
  }

  onNextPage() {
    this.page.emit({
      pageIndex: this.pageIndex + 1
    });
  }

  private getNumberOfPages() {
    return Math.ceil(this.length / this.pageSize);
  }
}
